@switch (columnName) {
  @case ('created') {
    {{ element.created | date: dateFormat }}
  }
  @case ('status') {
    {{ element.status | documentStatusMap | translate }}
  }
  @case ('documentVersionComment') {
    {{ element.comment }}
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
